import {pick} from 'lodash';
import {connect} from 'react-redux';
import {setNavigationAnnouncement} from 'shared/actions/accessibility-announcement';
import {expandFilter} from 'shared/actions/filters';
import {openModal} from 'shared/actions/modal';
import {
  getCollegeAppStatuses,
  setCollegeAppStatus,
} from 'shared/college-application-status/actions/college-application-status';
import CollegeSearch from 'src/components/CollegeSearch/CollegeSearch/CollegeSearch';
import {TERM_NOT_OFFERED_MODAL} from 'src/components/CollegeSearch/TermNotOfferedModal';
import {
  followCollege,
  getColleges,
  initializeCollegeSearch,
  resetPage,
  unfollowCollege,
  updateSortBy,
} from 'src/redux/collegeSearch/actions';

const mapStateToProps = (state) => ({
  ...pick(state, [
    'collegeSearch',
    'filters',
    'filtersInitialized',
    'modal',
    'collegeApplicationStatuses',
    'student',
  ]),
  userType: state?.collegeProfile?.userInfo?.user,
});

export default connect(mapStateToProps, {
  getColleges,
  followCollege,
  unfollowCollege,
  expandFilter,
  resetPage,
  updateSortBy,
  getCollegeAppStatuses,
  setCollegeAppStatus,
  setNavigationAnnouncement,
  initializeCollegeSearch,
  openTermNotOfferedModal: () => openModal(TERM_NOT_OFFERED_MODAL),
})(CollegeSearch);
